'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef } from 'react';
const SCROLL_MARGIN_PADDING = 16;
interface ScrollSectionProps<T extends string> {
  id: T;
  stickyOffset: number | string;
  onRegister: (id: T, element: HTMLElement | null) => void;
  label?: string;
  children?: ReactNode;
}
export function ScrollSection(t0) {
  const $ = _c(15);
  const {
    id,
    stickyOffset,
    onRegister,
    label,
    children
  } = t0;
  const sectionRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== id || $[1] !== onRegister) {
    t1 = () => {
      onRegister(id, sectionRef.current);
      return () => onRegister(id, null);
    };
    t2 = [id, onRegister];
    $[0] = id;
    $[1] = onRegister;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const t3 = `section-${id}`;
  const t4 = label ? "flex flex-col" : "gap-lg sm:gap-xl flex flex-col";
  const t5 = typeof stickyOffset === "number" ? stickyOffset + SCROLL_MARGIN_PADDING : `calc(${stickyOffset} + ${SCROLL_MARGIN_PADDING}px)`;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      scrollMarginTop: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== label) {
    t7 = label ? <><h2 className="text-title-xs mb-lg">{label}</h2><div className="gap-lg sm:gap-xl flex flex-col">{children}</div></> : children;
    $[6] = children;
    $[7] = label;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== id || $[10] !== t3 || $[11] !== t4 || $[12] !== t6 || $[13] !== t7) {
    t8 = <section ref={sectionRef} id={id} data-testid={t3} className={t4} style={t6}>{t7}</section>;
    $[9] = id;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}